import { keyMirror } from '@groove-labs/action-utils';

export type VisibilityStateType = 'OPENED' | 'MINIMIZED' | 'CLOSED';

export const VISIBILITY_STATES = keyMirror(['OPENED', 'MINIMIZED', 'CLOSED']);
